import React from 'react';
import AddToCart from '../../Cart/Components/AddToCart/AddToCart';
import { WishlistItemType } from '../../MyLom/Account/Wishlist/Types';

interface Props {
    item: WishlistItemType;
}

const WishlistPublicItem: React.FunctionComponent<Props> = (props) => {
    return (
        <div className="row align-items-center mix product-teaser-list product-teaser-list--user-default">
            <a href={props.item.link} className="col-md-3 d-flex justify-content-center">
                <img src={props.item.imageUri} />
            </a>
            <a href={props.item.link} className="col-md link-node">
                <h3 className="product-teaser-list__title">{props.item.title} </h3>
                <div className="product-price product-teaser-list__price">{props.item.price}</div>
                <div>{props.item.deliveryNote}</div>
            </a>
            <div className="offset-md-3 offset-lg-0 col-lg-auto product-teaser-list__actions">
                <AddToCart article={props.item} />
            </div>
        </div>
    );
};

export default WishlistPublicItem;
